export const SpinnerStyle = ``;
